import React from "react";
import {classNames} from "../../../../common/util/util-helpers";
import {STATUSES} from "./dot-inspection-config";

export default function DotInspectionItemRow({item, status, onChange, translate}) {
    return (
        <div className="flex flex-wrap items-center justify-between gap-3 py-2">
            <span className="text-sm text-tm-gray-900">{item.label}</span>

            <div className="flex items-center gap-1.5 shrink-0">
                {STATUSES.map((it) => (
                    <button
                        key={it.key}
                        type="button"
                        onClick={() => onChange(item.id, it.key)}
                        className={classNames(
                            "rounded-btn px-2.5 py-1 text-xs font-medium ring-1 ring-inset transition-colors",
                            status === it.key
                                ? it.activeClass
                                : "bg-inverse text-tm-gray-600 ring-tm-gray-300 hover:bg-tm-gray-100"
                        )}
                    >
                        {translate(it.labelKey)}
                    </button>
                ))}
            </div>
        </div>
    );
}
